$( document ).on("turbo:load", initStructureNfcTagModal);

function initStructureNfcTagModal() {
  if ($('#nfc-tag-modal').length > 0) {
    $('[data-function="existing-nfc-tag-list"]').hide();
    $('a[data-function="existing-nfc-tag"]').click(function(e){
      e.preventDefault();
      $('[data-function="existing-nfc-tag-list"]').show();
    });
  }
}
